import React from "react";
import { Lesson } from "@/types/tutor";
import LessonCardCompact from "./LessonCardCompact";

interface LessonListProps {
  lessons: Lesson[];
  classroomId: string;
  getAnalyticsHref?: (lessonId: number, lessonName: string) => string;
  onUnassign?: (lessonId: number) => void;
}

const LessonList: React.FC<LessonListProps> = ({
  lessons,
  classroomId,
  getAnalyticsHref,
  onUnassign,
}) => {
  return (
    <div className="et-group-lessons">
      {lessons.length === 0 ? (
        <p className="font-mulish text-sm text-[#9CA3AF] py-2">
          No lessons assigned to this group.
        </p>
      ) : (
        <table>
          <thead>
            <tr>
              <th scope="col">Lesson</th>
              <th scope="col">Assigned by</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {lessons.map((lesson, index) => (
              <LessonCardCompact
                key={lesson.id}
                lesson={lesson}
                index={index}
                classroomId={classroomId}
                analyticsHref={getAnalyticsHref?.(lesson.id, lesson.name)}
                onUnassign={onUnassign}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LessonList;
